import moment from 'moment';
import { Global } from '@/Config';

// Filtro para converter um objeto Date em uma string
// no formato Brasileiro de Data
export default (date, displayDateParam) => {
  let display = Global.format.displayDate;

  if (displayDateParam) {
    display = displayDateParam;
  }

  if (date) {
    return moment(String(date), Global.format.parseDateTime).format(display);
  }

  return '--';
};



// WEBPACK FOOTER //
// ./src/filters/PrDateFilter.js